import headline1 from "./headline1";
import headline2 from "./headline2";
import headline3 from "./headline3";

export default [headline1, headline2, headline3];
